import React, { Component } from 'react';
import { reduxForm, getFormValues, change as formChange } from 'redux-form';
import { connect } from 'react-redux';
import { isArr1ContainArr2 } from 'src/utils/Utils';
import isEmpty from 'lodash/isEmpty';

// Form
import {
  CLIENT_GROUPS,
  CLIENT_POSITIONS,
  CLIENT_OCCUPATIONS,
  CLIENT_EMPLOYMENT_TYPES
} from 'src/constants/EndpointUrls';
import { FormSubmitBtn } from 'src/buttons';
import { EMPLOYEE_SEARCH_FORM } from 'src/constants/FormNames';
import { TextField, SelectField, RadioField } from 'jbc-front/components/Form';
import ArrowDownSquare from 'jbc-front/components/icons/ArrowDownSquare';
import { Pulldown, Close } from 'jbc-front/components/icons';
import { InlineBlock, MemoColorsSection } from 'src/components';
import * as styles from './EmployeeSearchForm.scss';

const OTHER_SORT_OPTIONS = [
  { value: 'different_salary', label: '前月と基本給が異なる従業員のみ' },
  { value: 'different_commuting', label: '前月と通勤手当が異なる従業員のみ' },
  { value: 'joined_this_month', label: '当月に入社した従業員' },
  { value: 'retired_this_month', label: '当月に退職した従業員' }
];

const TARGET_EMPLOYEE_BONUS = [
  { value: 'all', label: 'すべて' },
  { value: 'checked_on', label: '対象者のみ' },
  { value: 'checked_off', label: '非対象者のみ' }
];

const SearchFieldRow = ({ label, options, onClickItem, selected, settingLink }) => (
  <tr>
    <th>{label}</th>
    <td>
      <div className={styles.flex}>
        {isEmpty(options) && (
          <span>
            現在{label}が設定されていません。<a href={settingLink}>[{label}の設定へ]</a>
          </span>
        )}
        {options.map(item => (
          <span
            key={item.value}
            className={selected(item.value) ? styles.active : styles.deactive}
            role="presentation"
            onClick={() => onClickItem(item.value)}
          >
            {item.label}
          </span>
        ))}
      </div>
    </td>
  </tr>
);

class EmployeeSearchRawForm extends Component {
  state = {
    showForm: true,
    showGroupSelect: false
  };

  changeShowForm = () => {
    this.setState({ showForm: !this.state.showForm });
  };

  handleKeyDown = (e, cb) => {
    if (e.key === 'Enter' && e.shiftKey === false) {
      e.preventDefault();
      cb();
    }
  };

  filedValue = field => {
    const { formValues = {} } = this.props;
    let value = formValues[field] || '';
    value = value ? value.split('_') : [];
    return value;
  };

  seleted = (field, id) => this.filedValue(field).indexOf(id.toString()) !== -1;

  selectedGroup = id => {
    const groups = this.filedValue('groupIds').map(item => item.split('/'));
    const checkArr = id.split('/');
    return groups.find(arr => isArr1ContainArr2(arr, checkArr));
  };

  changeFormField = (field, newId) => {
    const { dispatch } = this.props;
    const value = this.filedValue(field);
    const index = value.indexOf(newId);

    if (index !== -1) {
      value.splice(index, 1);
    } else {
      value.push(newId);
    }

    dispatch(formChange(EMPLOYEE_SEARCH_FORM, field, value.join('_')));
  };

  _changeShowGroup = () => {
    this.setState({ ...this.state, showGroupSelect: !this.state.showGroupSelect });
  };

  _changeGroupSelect = id => {
    const groups = this.filedValue('groupIds');
    if (this.selectedGroup(id) && groups.indexOf(id) === -1) {
      return;
    }
    this.changeFormField('groupIds', id);
  };

  get selectingGroup() {
    const { employeeGroups = [] } = this.props;
    const groups = this.filedValue('groupIds');
    if (groups.length === 0) {
      return 'グループ選択';
    } else if (groups.length === 1) {
      return (employeeGroups.find(item => item.value === groups[0]) || {}).label;
    }
    return '複数のグループ選択中';
  }

  render() {
    const {
      handleSubmit,
      employeeGroups,
      clientEmploymentTypes,
      employeeOccupations,
      employeePositions,
      memoColorMappings,
      submitting,
      submit,
      clientPayrollRulesGroupsWithName,
      queries,
      showOtherSearch,
      showTargetBonusSearch
    } = this.props;

    let { payrollRulesGroups } = queries;
    let selectOptions = clientPayrollRulesGroupsWithName;
    if (payrollRulesGroups) {
      payrollRulesGroups = payrollRulesGroups.split('_');
      selectOptions = clientPayrollRulesGroupsWithName.filter(group => payrollRulesGroups.includes(`${group.value}`));
    }

    const icon = this.state.showForm ? <Close size={30} /> : <Pulldown size={30} />;
    return (
      <form
        onSubmit={handleSubmit}
        className={styles.search}
        onKeyDown={e => {
          this.handleKeyDown(e, handleSubmit);
        }}
        role="presentation"
      >
        <InlineBlock>
          <TextField name="nameCnt" placeholder="スタッフコード、氏名" />
          <FormSubmitBtn name="submit" text="検索" {...{ submitting, submit }} />
          <span name="pulldown" role="presentation" onClick={this.changeShowForm}>
            {icon}
          </span>
        </InlineBlock>
        <input type="hidden" name="groupIds" />
        <input type="hidden" name="occupationIds" />
        <input type="hidden" name="employmentTypeIds" />
        <input type="hidden" name="positionIds" />
        {this.state.showForm && (
          <div>
            <table className="m-table-list">
              <tbody>
                <tr>
                  <th>グループ</th>
                  <td>
                    <div style={{ cursor: 'pointer' }} onClick={this._changeShowGroup} role="presentation">
                      {this.selectingGroup} <ArrowDownSquare />
                    </div>
                    {isEmpty(employeeGroups) && (
                      <span className={styles.flex}>
                        現在グループが設定されていません。<a href={CLIENT_GROUPS}>[グループの設定へ]</a>
                      </span>
                    )}
                    {this.state.showGroupSelect &&
                      employeeGroups.map(group => (
                        <div
                          key={group.value}
                          className={
                            this.selectedGroup(group.value.toString()) ? styles.activegroup : styles.deactivegroup
                          }
                          onClick={() => this._changeGroupSelect(group.value.toString())}
                          role="presentation"
                        >
                          {group.label}
                        </div>
                      ))}
                  </td>
                </tr>
                <SearchFieldRow
                  label="職種"
                  options={employeePositions}
                  onClickItem={id => this.changeFormField('positionIds', id.toString())}
                  selected={id => this.seleted('positionIds', id)}
                  settingLink={CLIENT_POSITIONS}
                />
                <SearchFieldRow
                  label="雇用形態"
                  options={clientEmploymentTypes}
                  onClickItem={id => this.changeFormField('employmentTypeIds', id.toString())}
                  selected={id => this.seleted('employmentTypeIds', id)}
                  settingLink={CLIENT_EMPLOYMENT_TYPES}
                />
                <SearchFieldRow
                  label="役職"
                  options={employeeOccupations}
                  onClickItem={id => this.changeFormField('occupationIds', id.toString())}
                  selected={id => this.seleted('occupationIds', id)}
                  settingLink={CLIENT_OCCUPATIONS}
                />
                <tr>
                  <th>給与規定グループ</th>
                  <td>
                    <div className={styles.payrollRulesGroup}>
                      <SelectField widthAuto name="payrollRulesGroup" options={selectOptions} placeholder="すべて" />
                    </div>
                  </td>
                </tr>
                <MemoColorsSection memoColorMappings={memoColorMappings} name="memoColorMappings" />
                {showOtherSearch && (
                  <tr>
                    <th>その他</th>
                    <td>
                      <div className={styles.payrollRulesGroup}>
                        <SelectField widthAuto name="otherSearch" options={OTHER_SORT_OPTIONS} placeholder="すべて" />
                      </div>
                    </td>
                  </tr>
                )}
                {showTargetBonusSearch && (
                  <tr>
                    <td>賞与支給対象者</td>
                    <td>
                      <RadioField required name="bonusTarget" label="" options={TARGET_EMPLOYEE_BONUS} />
                    </td>
                  </tr>
                )}
                <tr>
                  <td colSpan={2}>
                    <FormSubmitBtn name="submit" text="検索" {...{ submitting, submit }} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </form>
    );
  }
}

const EmployeeSearchForm = reduxForm({
  form: EMPLOYEE_SEARCH_FORM
})(EmployeeSearchRawForm);

export default connect(state => ({
  formValues: getFormValues(EMPLOYEE_SEARCH_FORM)(state)
}))(EmployeeSearchForm);
